var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeDisagreeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 10,
    fill: "#152549"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7156 22.1612L35.4242 18.0646C34.7415 17.3818 33.2053 17.0405 32.1811 17.0405H25.6949C23.6467 17.0405 21.4277 18.5767 20.9156 20.6249L16.8191 33.0853C15.9656 35.4749 17.5018 37.5232 20.0622 37.5232H26.8898C27.9139 37.5232 28.7673 38.3767 28.5967 39.5715L27.7432 45.0336C27.4018 46.5698 28.426 48.2767 29.9622 48.7887C31.3277 49.3008 33.0346 48.6181 33.7173 47.5939L40.7156 37.1818",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4202 22.1612V38.8888C49.4202 41.2784 48.3961 42.1319 46.0064 42.1319H44.2995C41.9099 42.1319 40.8857 41.2784 40.8857 38.8888V22.1612C40.8857 19.7715 41.9099 18.9181 44.2995 18.9181H46.0064C48.3961 18.9181 49.4202 19.7715 49.4202 22.1612Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeDisagreeIcon);
export default __webpack_public_path__ + "static/media/takeDisagreeIcon.91ca7270310337501c6b7664feac431f.svg";
export { ForwardRef as ReactComponent };